import { CommonModule } from '@angular/common';
import { APP_INITIALIZER } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, importProvidersFrom, isDevMode } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  RouterModule,
  provideRouter,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './app/auth/auth-config';

import { default as routes } from './app/app-routes';
import { AppComponent, getAppKey, getBaseUrl, getLoginUrl, getPublicBaseUrl } from './app/app.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      CommonModule,
      NgbModule,
      RouterModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000',
      }),
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: ['https://api.assistonline.eu'],
          sendAccessToken: true,
        },
      })
    ),
    { provide: 'LOGIN_URL', useFactory: getLoginUrl, deps: [] },
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: 'PUBLIC_BASE_URL', useFactory: getPublicBaseUrl, deps: [] },
    { provide: 'APP_KEY', useFactory: getAppKey, deps: [] },
    { provide: LOCALE_ID, useValue: 'nl-BE' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled' }),
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: (oauthService: OAuthService) => {
        return () => {
          oauthService.configure(authConfig);
          oauthService.setStorage(localStorage); // gebruik sessionStorage als je dat liever hebt
         
          return oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
            const params = new URLSearchParams(window.location.search);
            const hasToken = oauthService.hasValidAccessToken(),
              hasCode = params.has('code');
            if (params.get('activated') == '1' && !hasToken) {
              sessionStorage.setItem('returnUrl', window.location.href);
              oauthService.initCodeFlow();
            }
          
            const returnUrl = sessionStorage.getItem('returnUrl');

            if (hasToken && returnUrl) {
              sessionStorage.removeItem('returnUrl');
              window.location.replace(returnUrl);
            }
          });
        };
      },
      deps: [OAuthService],
      multi: true,
    }
    ,
  ],
}).catch((err) => console.error(err));
